<template>
  <div class="main">
    <div class="timeline">
      <Timeline ref="timeLine" :method-being-called="getAllData"/>
      <h4 class="main-header">Main Dashboard</h4>
    </div>
    <div class="dash">
      <div class="bar-chart-desktop-screen">
        <div class="chart-header">
          <h5 class="chart-title truncated-text">Franchise Sales</h5>
          <span class="">
            <button class="general-btn mx-2" @click="printFranchiseTurnoverPDF">
              <font-awesome-icon :icon="['fas', 'print']"/>
              Print
            </button>
            <button
                class="general-btn-excel my-2"
                @click="printFranchiseTurnoverCSV"
            >
              <font-awesome-icon :icon="['fas', 'table']"/>
              Excel
            </button>
          </span>
        </div>
        <div class="card">
          <div class="card-body">
            <BarChart
                :chart-data="BarChartData"
            />
          </div>
        </div>
      </div>
      <div class="chart-mobile-screen d-none">
        <div class="chart-header">
          <h5 class="chart-title">Franchise Sales</h5>
          <span class="d-flex justify-content-center align-items-center">
            <button class="general-btn mx-2" @click="printFranchiseTurnoverPDF">
              <font-awesome-icon :icon="['fas', 'print']"/>
              Print
            </button>
            <button
                class="general-btn-excel my-2"
                @click="printFranchiseTurnoverCSV"
            >
              <font-awesome-icon :icon="['fas', 'table']"/>
              Excel
            </button>
          </span>
        </div>
        <div>
          <div id="sales-data">
            <div
                v-for="(store, index) in visibleStores"
                :key="index"
                class="branch"
            >
              <h5>{{ store.store }}</h5>
              <p><strong>Turn Over:</strong> {{ store.turnOver }}</p>
              <p><strong>Cost of Sales:</strong> {{ store.costOfSales }}</p>
              <p><strong>Net Profit:</strong> {{ store.profit }}</p>
            </div>

            <button
                class="showMore"
                v-if="showToggleButton"
                @click="toggleStores"
            >
              {{ showMoreStores ? "Show Less Stores" : "Show More Stores" }}
            </button>
          </div>
        </div>
      </div>

      <div class="charts1 mx-2 my-2">
        <div class="sales-overview-container">
          <div class="sales-overview">
            <div class="revenue-overview-stats justify-content-start row">
              <div class="col-lg-8 col-md-8 col-sm-12">
                <div class="d-flex flex-wrap">
                  <div class="col-lg-8 col-md-8 col-sm-12">
                    <h5 class="heading">REVENUE</h5>
                    <div class="rev-stats d-flex flex-wrap">
                      <span class="rev-items">
                        <p
                            v-if="!$store.getters.getLoadingState"
                        >
                          {{ $utils.formatDefaultCurrency(revenue.salesTotal) }}
                        </p>
                        <p v-else>Loading</p>
                        <h6 class="text-nowrap">Sales Total</h6>
                      </span>
                      <span class="rev-items">
                        <p v-if="!$store.getters.getLoadingState">
                          {{ $utils.formatDefaultCurrency(revenue.quoteValue) }}
                        </p>
                        <p v-else>Loading</p>
                        <h6 class="text-nowrap">Open tables/Quotes value</h6>
                      </span>
                      <span class="rev-items">
                        <p v-if="!$store.getters.getLoadingState" >
                          {{ $utils.formatDefaultCurrency(revenue.costOfSales) }}
                        </p>
                        <p v-else>Loading</p>
                        <h6 class="text-nowrap">Cost of Sales</h6>
                      </span>
                      <span class="rev-items">
                        <p v-if="!$store.getters.getLoadingState">
                          {{ $utils.formatDefaultCurrency(revenue.grossProfit) }}
                        </p>
                        <p v-else>Loading</p>
                        <h6 class="text-nowrap">Gross Profit</h6>
                      </span>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-3 col-sm-12">
                    <h5 class="heading">EXPENSES</h5>
                    <div class="rev-stats">
                      <span class="rev-items">
                        <p v-if="!$store.getters.getLoadingState" >
                          {{ $utils.formatDefaultCurrency(revenue.expenseValue) }}
                        </p>
                        <p v-else>Loading</p>
                        <h6 class="text-nowrap">Total Expenses</h6>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-wrap">
                  <div class="col-lg-8 col-md-8 col-sm-12">
                    <h5 class="heading text-nowrap">POSITIVE POSITION</h5>
                    <div class="pos-stats d-flex flex-wrap">
                      <span class="pos-items">
                        <p v-if="!$store.getters.getLoadingState">
                          {{ $utils.formatDefaultCurrency(positivePosition.stockValue) }}
                        </p>
                        <p v-else>Loading</p>
                        <h6 class="text-nowrap">Stock Value</h6>
                      </span>
                      <span class="pos-items">
                        <p v-if="!$store.getters.getLoadingState">
                          {{ $utils.formatDefaultCurrency(positivePosition.debtorBalance) }}
                        </p>
                        <p v-else>Loading</p>
                        <h6>Debtors</h6>
                      </span>
                      <span class="pos-items">
                        <p v-if="!$store.getters.getLoadingState">
                          {{ $utils.formatDefaultCurrency(positivePosition.inputVatTotal) }}
                        </p>
                        <p v-else>Loading</p>
                        <h6 class="text-nowrap">Input Vat Total</h6>
                      </span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <h5 class="heading text-nowrap">NEGATIVE POSITION</h5>
                    <div class="pos-stats d-flex flex-wrap">
                      <span class="pos-items">
                        <p
                            v-if="
                            negativePosition.supplierBalance !== undefined &&
                            negativePosition !== null
                          "
                        >
                          {{
                            $utils.formatMoney(negativePosition.supplierBalance)
                          }}
                        </p>
                        <p v-else>Loading</p>
                        <h6 class="text-nowrap">Supplier Balance</h6>
                      </span>
                      <span class="pos-items">
                        <p
                            v-if="
                            negativePosition.supplierBalance !== undefined &&
                            negativePosition !== null
                          "
                        >
                          {{ $utils.formatMoney(negativePosition.outPutVat) }}
                        </p>
                        <p v-else>Loading</p>
                        <h6 class="text-nowrap">Output Vat</h6>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="top col-lg-3 col-md-4 col-sm-12">
                <div
                    v-if="hasData"
                    class="d-flex flex-column justify-content-center align-items-center"
                >
                  <PieChart :chart-data="chartData" :width="250"/>
                  <p class="text-secondary text-sm-center">
                    Department Performance
                  </p>
                </div>
                <div v-else class="no-data-container">
                  <svg width="300" height="350">
                    <circle cx="150" cy="175" r="100" fill="#f3f4f7"/>
                    <text
                        x="150"
                        y="180"
                        text-anchor="middle"
                        fill="black"
                        font-size="14"
                    >
                      No Data in Chart
                    </text>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Timeline from "@/utils/TimelineSelection/Timeline.vue";
import PieChart from "@/components/charts/Pie.js";
import BarChart from "@/components/charts/BarChart.js";
import {utils as $utils} from "../../Services/utils";

export default {
  name: "Dashboard",
  mounted() {
    this.getAllData();
    window.addEventListener("keydown", this.handleKeydown);
  },
  beforeUnmount() {
    // Remove the event listener when the component is unmounted
    window.removeEventListener("keydown", this.handleKeydown);
  },
  computed: {
    $utils() {
      return $utils;
    },
    visibleStores() {
      return this.showMoreStores ? this.stores : this.stores.slice(0, 2);
    },
    showToggleButton() {
      return this.stores.length > 3;
    },

    hasData() {
      return this.chartData?.datasets?.some((dataset) =>
          dataset.data.some((value) => value > 0)
      );
    },

    totalStock() {
      return this.storeData.reduce(
          (total, store) => total + store.totalStock,
          0
      );
    },

    stockValue() {
      return this.storeData.reduce((total, store) => total + store.belowMin, 0);
    },
    currentStore() {
      return this.$store.getters.getStore;
    },
  },
  components: {
    Timeline,
    PieChart,
    BarChart,
  },
  data() {
    return {
      revenue: [],
      negativePosition: [],
      positivePosition: [],
      totalStockValue: 0.0,
      // chartOptions: {
      //   indexAxis: "x",
      // },
      stores: [],
      showMoreStores: false,
      BarChartData: {
        labels: [],
        datasets: [
          {
            label: "Turn Over",
            backgroundColor: "#41aeb8",
            data: [],
          },
          {
            label: "Cost of Sales",
            backgroundColor: "#E46651",
            data: [],
          },
          {
            label: "Net Profit",
            backgroundColor: "#41B883",
            data: [],
          },
        ],
      },

      chartData: {
        labels: [],

        datasets: [
          {
            backgroundColor: [
              "#419883",
              "#E46651",
              "#00D8FF",
              "#DD1B16",
              "#115845",
              "#775566",
              "#721266",
              "#275856",
              "#721206",
              "#275866",
            ],
            data: [],
          },
        ],
      },
    };
  },
  methods: {
    toggleStores() {
      this.showMoreStores = !this.showMoreStores;
    },
    handleKeydown(event) {
      if (event.ctrlKey) {
        switch (event.key.toLowerCase()) {
          case "s":
            event.preventDefault();
            alert("Save action triggered in this component");
            // Add your save logic here
            break;
          case "p":
            event.preventDefault();
            alert("Print action triggered in this component");
            // Add your print logic here
            break;
          default:
            break;
        }
      }
    },
    async getAllData() {
      try {
        this.$utils.showLoading();

        const results = await Promise.allSettled([
          this.getTurnOverData(),
          this.getFranchiseRevenue(),
          this.getPositivePosition(),
          this.getNegativePosition(),
          this.getTopCategories(),
        ]);
        results.forEach((result, index) => {
          if (result.status === "rejected") {
            console.error(`Promise ${index} failed:`, result.reason);
          }
        });
      } catch (error) {
        console.error("Unexpected error:", error);
      } finally {
        this.$utils.hideLoading();
      }
    },

    async getTurnOverData() {
      try {
        this.BarChartData = {
          labels: [],
          datasets: [
            {
              label: "Turn Over",
              backgroundColor: "#41aeb8",
              data: [],
            },
            {
              label: "Cost of Sales",
              backgroundColor: "#E46651",
              data: [],
            },
            {
              label: "Net Profit",
              backgroundColor: "#41B883",
              data: [],
            },
          ],
        }
        const res = await this.$store.dispatch("getTurnOverData");
        console.log({res})
        this.stores = res;
        this.BarChartData = {
          labels: res.map((r) => r.store),
          datasets: [
            {
              label: "Turn Over",
              backgroundColor: "#41aeb8",
              data: res.map((r) => r.turnOver),
            },
            {
              label: "Cost of Sales",
              backgroundColor: "#E46651",
              data: res.map((r) => r.costOfSales),
            },
            {
              label: "Net Profit",
              backgroundColor: "#41B883",
              data: res.map((r) => r.profit),
            },
          ],
        };

        this.totalStockValue = res.reduce(
            (total, result_4) => total + result_4.stockValue,
            0
        );
      } catch (error) {
      } finally {
        return;
      }
    },

    async getFranchiseRevenue() {
      try {
        const data = await this.$store.dispatch("getFranchiseRevenue");
        this.revenue = data;
      } catch (error) {
      } finally {
        return;
      }
    },

    async getPositivePosition() {
      try {
        const data = await this.$store.dispatch("getPositivePosition");
        this.positivePosition = data;
      } catch (error) {
      } finally {
        return;
      }
    },

    async getNegativePosition() {
      try {
        let data = await this.$store.dispatch("getNegativePosition");
        this.negativePosition = data;
      } catch (error) {
        console.error(error);
      } finally {
        return;
      }
    },

    async getTopCategories() {
      let query = {};
      try {
        const categories = await this.$store.dispatch("getSalesData", {
          route: "businessOverview/top10DepartmentSales",
          query,
        });

        // Extract labels and data for the pie chart
        this.chartData.labels = categories.map((item) => item.department);
        this.chartData.datasets[0].data = categories.map((item) => item.total);
      } catch (error) {
        console.error("Failed to fetch top categories:", error);
      } finally {
        return;
      }
    },

    async printFranchiseTurnoverPDF() {
      try {
        return await this.$store.dispatch("printFranchiseTurnoverPDF");
      } finally {
        return;
      }
    },
    async printFranchiseTurnoverCSV() {
      try {
        return await this.$store.dispatch("printFranchiseTurnoverCSV");
      } finally {
        return;
      }
    },
  },
  watch: {
    currentStore(newStore, oldStore) {
      if (newStore.StoreDB !== oldStore.StoreDB) {
        this.getAllData();
      }
    },
  },
};
</script>

<style scoped>
#sales-data {
  margin: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.branch {
  background-color: var(--card-bg);
  padding: 10px;
  border-radius: var(--radius-card);
  border-bottom: 1px solid var(--grid-lines);
  margin-bottom: 15px;
  width: 100%;
}

.branch h5 {
  margin: 0;
  color: var(--accent-primary);
  font-weight: 600;
}

.branch p {
  margin: 5px 0;
  color: var(--text-secondary);
}

.charts1 {
  margin-bottom: 5rem;
}

.main {
  height: 100%;
  overflow-y: auto;
}

.info-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 20px;
  width: 100%;
  margin-right: 6rem;
}

.doughnut-info {
  display: flex;
  justify-content: center;
  align-items: center;
}

.legend-item {
  display: flex;
  align-items: center;
  margin-right: 1rem;
}

.top {
  max-height: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media only screen and (max-width: 699px) {
  .top {
    border-top: var(--grid-lines) 2px dashed;
  }
}

@media only screen and (max-width: 1500px) {
  .info-container {
    display: none !important;
  }
}

@media only screen and (max-width: 600px) {
  .bar-chart-desktop-screen {
    display: none !important;
  }

  .chart-mobile-screen {
    display: block !important;
  }
}

@media only screen and (max-width: 699px) {
  .top {
    margin-top: 0.2rem;
    margin-bottom: 5rem;
    border-top: var(--grid-lines) 2px dashed;
  }

  .doughnut-info {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .info-container {
    grid-template-columns: 1fr;
    width: 100%;
    overflow-y: auto;
    margin-top: 5rem;
  }
}

.bar-chart-desktop-screen {
  background-color: var(--card-bg);
  border-radius: var(--radius-card);
  padding: 10px 20px;
  margin: 0 15px 0 15px;
  /*-webkit-box-shadow: 5px -3px 14px -9px rgba(0, 0, 0, 0.75);*/
  /*-moz-box-shadow: 5px -3px 14px -9px rgba(0, 0, 0, 0.75);*/
  /*box-shadow: 5px -3px 14px -9px rgba(0, 0, 0, 0.75);*/
}

h6 {
  text-wrap: nowrap;
  font-size: 18px;
}

.rev-stats,
.pos-stats {
  display: flex;
  gap: 2px;
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;
}

.rev-items,
.pos-items {
  margin-top: 10px;
  text-align: start;
  margin-right: 20px;
  line-height: 1px;
  padding: 1px;
  gap: 1rem;
  color: var(--text-secondary);
}

.rev-items p,
.pos-items p {
  font-size: 26px;
  font-weight: 600;
  color: var(--text-secondary);
}

.heading {
  color: var(--accent-primary);
  font-weight: 600;
  margin-bottom: 15px;
  font-size: 20px !important;
}

.line {
  width: 95%;
  border-bottom: 2px solid var(--grid-lines);
}

.charts {
  width: 100%;
  height: 500px;
}

.charts > .chart {
  background-color: var(--card-bg);
  padding: 20px;
  font-size: 1.5rem;
  color: var(--text-primary);
  border-radius: var(--radius-card);
  min-height: 150px;
}

.revenue-overview-stats {
  margin: 10px;
  background-color: var(--card-bg);
  border-radius: var(--radius-card);
  padding: 10px 20px;
  min-width: 250px;
  min-height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  font-size: 3rem;
  color: var(--accent-primary);
  border-radius: var(--radius-card);
  background-color: var(--card-bg);
  padding: 10px !important;
}

@media only screen and (min-width: 1200px) {
  .charts12 > div {
    background-color: var(--card-bg);
    padding: 20px;
    font-size: 1.5rem;
    color: var(--text-primary);
    border-radius: var(--radius-card);
    min-height: 150px;
    max-height: 450px;
  }
}

@media only screen and (max-width: 760px) {
  .bar-chart-desktop-screen {
    padding: 10px 20px;
    margin: 0 5px 0 5px;
  }

  .revenue-overview-stats {
    margin: 0;
    padding: 10px 0;
  }
}

@media only screen and (max-width: 450px) {
  .rev-items p,
  .pos-items p {
    font-size: 19px;
  }
}

.mobile-screen {
  display: none;
}

@media only screen and (max-width: 699px) {
  .mobile-screen {
    display: block;
  }

  .desktop-screen {
    display: none !important;
  }
}


</style>
